import { render, staticRenderFns } from "./LastModify.vue?vue&type=template&id=0be01e54"
import script from "./LastModify.vue?vue&type=script&lang=js"
export * from "./LastModify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports